import { Button, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { getPaymentAmount, mpgsSession } from "@/services/Pledge/PledgeApis";
import { useAuthStore } from "@/stores/authStore";
import { useRenewStore } from "@/stores/renewStore";
import { usePledgesStore } from "@/stores/usePledgesStore";
import { TenantMasterDataInterface } from "@/types/authService";
import {
  ERenewPaymentDetails,
  PaymentAmountDetail,
  PaymentAmountResponse,
} from "@/types/pledgeService";

import styles from "./MpgsConfirmModal.module.css";

interface Props {
  open: boolean;
  onClose: () => void;
  selectedVoucher: any;
  tenantMasterData: TenantMasterDataInterface[];
}
const MPGSConfirmModal: React.FC<Props> = ({
  open,
  onClose,
  selectedVoucher,
  tenantMasterData,
}) => {
  // const { selectedPledgeData, downloanAmount } = useRenewStore();
  const { currency } = useAuthStore();
  const [paymentDetails, setPaymentDetails] = useState<PaymentAmountResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { pledges } = usePledgesStore();
  const getPaymentDetails = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const params = {
        pledge_ids: pledges?.map((item) => item?.id).join(","),
        downloan_amount: pledges?.map((item) => item?.downloanAmount).join(","),
        ...(selectedVoucher?.voucher_code && { voucher_code: selectedVoucher?.voucher_code }),
        payment_type: "MPGES",
      };
      const response = (await getPaymentAmount(params)) as PaymentAmountResponse;
      setPaymentDetails(response);
    } catch (error) {
      console.error("Error fetch payment details", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    void getPaymentDetails();
  }, []);
  const openMPGSPayment = (sessionId: string) => {
    if (!(window as any).Checkout) {
      console.error("MPGS Checkout not loaded");
      return;
    }

    (window as any).Checkout.configure({
      session: {
        id: sessionId,
      },
    });

    (window as any).Checkout.showPaymentPage();
  };
  const getDownloanAmount = (paymentDetails: PaymentAmountDetail[]): number => {
    return paymentDetails?.reduce((acc, item) => {
      return (acc = acc + item?.downloan_amount);
    }, 0);
  };
  const submitRenewalHelper = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const payload = {
        pledges: pledges?.map((item) => ({
          old_pledge_id: item?.id,
          ...(item?.downloanAmount && { downloan_amount: item?.downloanAmount }),
        })),
        ...(selectedVoucher?.voucher_code && { voucher_code: selectedVoucher?.voucher_code }),
        payment_description: "Pledge Renew",
        payment_type: "mpgs",
        is_downloan: getDownloanAmount(paymentDetails?.details ?? []) ? true : false,
      };
      const response = await mpgsSession(payload);
      if (response?.session_id) {
        openMPGSPayment(response.session_id);
      }
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Modal
      title="Review & Confirm Payment"
      open={open}
      onCancel={onClose}
      footer={null}
      width={700}
      centered
    >
      <Spin spinning={isLoading}>
        <div className={styles.mainContainer}>
          <div className={styles.paymentBrakeDown}>
            <div className={styles.paymentBrakeDownItem}>
              <span>{`Total Pledge Amount (${currency})`}</span>{" "}
              <span>{paymentDetails?.summary?.total_pledge_amount}</span>
            </div>
            {selectedVoucher?.voucher_code && (
              <div className={styles.paymentBrakeDownItem}>
                <span>{`Voucher Discount Amount (${currency})`}</span>{" "}
                <span>{selectedVoucher?.voucher_value}</span>
              </div>
            )}
            <div className={styles.paymentBrakeDownItem}>
              <span>{`Total Interest (${currency})`}</span>{" "}
              <span>{paymentDetails?.summary?.total_interest_amount}</span>
            </div>
            <div className={styles.paymentBrakeDownItem}>
              <span>{`Admin Fee (${currency})`}</span>{" "}
              <span>{paymentDetails?.summary?.total_admin_fee}</span>
            </div>
            {getDownloanAmount(paymentDetails?.details ?? []) ? (
              <div className={styles.paymentBrakeDownItem}>
                <span>{`Total Downloan Amount (${currency})`}</span>{" "}
                <span>{getDownloanAmount(paymentDetails?.details ?? [])}</span>
              </div>
            ) : null}
            {
              <div className={styles.paymentBrakeDownItem}>
                <span>{`Convenience Fee (%)`}</span>{" "}
                <span>{paymentDetails?.details?.[0]?.convenience_fee_percentage ?? 0}</span>
              </div>
            }
            <div className={styles.paymentBrakeDownItemNetPayable}>
              <span>{`Net Payable (${currency})`}</span>{" "}
              <span>{paymentDetails?.summary?.total_payable_amount}</span>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <Button className={styles.cancel} onClick={onClose}>
              Cancel
            </Button>
            <Button className={styles.confirm} onClick={submitRenewalHelper}>
              Confirm
            </Button>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default MPGSConfirmModal;
